import { useState } from 'react';

const isRememberMe = () => {
    return localStorage.get('isRemebmerMe');
}

export default function useToken() {
    const getToken = () => {
        let userTokenFromSessionStore = '';
        let userTokenFromLocalStore = '';
        try {
            userTokenFromSessionStore = JSON.parse(sessionStorage.getItem('token'));
            userTokenFromLocalStore = JSON.parse(localStorage.getItem('token'));
        }
        catch (ex){
        }
        return userTokenFromSessionStore ? userTokenFromSessionStore : userTokenFromLocalStore;
    };

    const [token, setToken] = useState(getToken());

    const saveToken = (userToken, rememberMe) => {
        sessionStorage.setItem('token', JSON.stringify(userToken));
        if(rememberMe){
            localStorage.setItem('token', JSON.stringify(userToken));
        }
        setToken(userToken);
    };

    const deleteToken = () => {
        sessionStorage.removeItem("token")
        localStorage.removeItem("token")
        setToken(null);
    }

    return {
        setToken: saveToken,
        deleteToken: deleteToken,
        getToken: getToken,
        token
    }
}